import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {productionActivityDto} from './defaultResponseModel/productionActivity';
const FUNCTION_CODE = 'GET_PRODUCTION_ACTIVITY';

export async function getProductionActivity(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/codev/production-activity/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return productionActivityDto.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
